import {Component, Host, h, Prop} from '@stencil/core';
import {CompanyViewModel} from "@modules/onBoarding/presentation/viewModel/CompanyViewModel";
import {AlreadyRegisteredViewModel} from "@modules/onBoarding/presentation/viewModel/AlreadyRegisteredViewModel";

@Component({
    tag: 'already-registered-view',
    styleUrl: 'already-registered-view.css',
    scoped: true,
})
export class AlreadyRegisteredView {

    @Prop() viewModel: AlreadyRegisteredViewModel;
    @Prop() company: CompanyViewModel;

    render() {
        return (
            <Host>
                <div id="already-registered-view" class="d-flex justify-content-center bg-primary position-relative">
                    <div class="container position-absolute">
                        <svg class="my-3" aria-hidden="true" width="100%" height="2rem">
                            <use data-href={this.viewModel.taglineHref}></use>
                        </svg>
                        <div class="card shadow d-flex flex-column flex-lg-row">
                            <div class="px-4 px-lg-5 py-4 flex-grow-1">
                                <div class="mb-4">
                                    <a href={this.viewModel.modifySearchLink} data-testid="onboarding.already-registered.leftblock.modifySearchLink">{this.viewModel.modifySearch}</a>
                                </div>
                                <div class="mb-4">
                                    <h2 class="title title_xs text-primary">{this.viewModel.companyAlreadyRegistered}</h2>
                                </div>
                                <div class="pt-3 pb-4 border-bottom-1 d-flex flex-column" data-testid="onboarding.already-registered.leftblock.companyInfos">
                                    <company-infos company={this.company}></company-infos>
                                </div>
                                <hr class="bg-lyreco-green"/>
                            </div>
                            <aside class="p-4 d-flex align-items-center bg-lyreco-light" id="nextActionBlock">
                                <div>
                                    <h2 class="mb-3 title title_md text-center">{this.viewModel.whatToDoNext}</h2>
                                    <span class="mb-2">{this.viewModel.requestNewCredentials}</span>
                                    <a href={this.viewModel.requestAccessLink}>
                                        <button class="btn btn-primary mt-2 w-100 text-white" data-testid="onboarding.already-registered.rightblock.button">{this.viewModel.requestAccess}</button>
                                    </a>
                                    <div class="mt-4 d-flex flex-column text-center">
                                        <a href={this.viewModel.resetPasswordLink} data-testid="onboarding.already-registered.rightblock.resetLink">{this.viewModel.resetPassword}</a>
                                        <span>{this.viewModel.or}</span>
                                        <a href={this.viewModel.contactCustomerSupportLink} data-testid="onboarding.already-registered.rightblock.contactLink">{this.viewModel.contactCustomerSupport}</a>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
